/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.mlr',['ngResource', 'common.helper']).factory('MLRReport', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/mlr/measures/', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}).service('MlrReportModel', function(MLRReport, $q, CommonHelper, CONSTANTS){
    var model = this,
    searchCriteria = {};
    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.resetSearchCriteria = function(){
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.ascending = true;
    };
    model.reset = function(){
        model.resetSearchCriteria();
    };

    model.reset();

    model.searchMeasures = function(page){
        var deferred = $q.defer();
        searchCriteria.commodityCodeFrom = CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeFrom);
        searchCriteria.commodityCodeTo = CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeTo);

        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            regulationPrefix: CommonHelper.removeSpaceCharacters(searchCriteria.regulationPrefix),
            regulationNumber: CommonHelper.removeSpaceCharacters(searchCriteria.regulationNumber),
            regulationYear: CommonHelper.removeSpaceCharacters(searchCriteria.regulationYear),
            commodityCodeFrom: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeFrom),
            commodityCodeTo: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeTo),
            sortOrder: searchCriteria.ascending? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };
    	if (page) {
    		options.offset =  CommonHelper.getOffset(page);
    		options.count = CONSTANTS.rowsPerPage;
    	}
        var result = MLRReport.query(options, function () {
            var searchResult = {};
            searchResult.totalItems = result.count;
            searchResult.measures = result.items;
            searchResult.regulationHead =  result.regulationHead;
            searchResult.simulationDate = searchCriteria.simulationDate;
            searchResult.commodityCodeFrom = searchCriteria.commodityCodeFrom;
            searchResult.commodityCodeTo = searchCriteria.commodityCodeTo;
            if (page) {
            	searchResult.currentPage= page;
            }
            deferred.resolve(searchResult);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

});



// WEBPACK FOOTER //
// ./app/taric/report/mlr/mlr-model.js